import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { CommonModule } from '@angular/common';
import { NotificationDetailsService } from '../notification-details.service';
import { FileUploadMultipleComponent } from '../../../create-notification/file-upload/file-upload-multiple/file-upload-multiple.component';
import { FileUploadMultipleService } from '../../../create-notification/file-upload/file-upload-multiple/file-upload-multiple.service';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'dl-attachment-modification',
  standalone: true,
  imports: [
    OneWebComponentsAngularModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    FileUploadMultipleComponent,
  ],
  templateUrl: './attachment-modification.component.html',
  styleUrls: ['./attachment-modification.component.scss'],
})
export class AttachmentModificationComponent implements OnInit {
  attachments: any[] = []; // your list
  selectAll = false;
  isAdding: boolean = false;

  hasSelection = false;

  isScrolled = false;
  filesData: any[];
  uploadingFiles: any[] = [];
  newUploadedFiles: any[];

  @ViewChild('parentScroll') parentScroll!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  @Input() data: any;
  @Output() justification = new EventEmitter<any>();
  @Output() allAddedFiles = new EventEmitter<any>();
  @Output() openCall = new EventEmitter<any>();
  public addJustification = new FormControl('', [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(500),
  ]);
  visibleisDeletionConfirmation: boolean = false;
  docsDataForDeletion: any;
  attachmentDataForDeletion: any;
  allAttachments: any[] = [];
  filteredGLobalAttachments: any;
  filteredLocalAttachments: any;
  public selectedIds: Set<number> = new Set();
  public storedData;
  public fileData;
  public output;
  public selectedItems = [];

  constructor(
    private snackBarNotification: SnackbarService,
    private qnsbnservice: QnSbnService,
    private notificationDetailsService: NotificationDetailsService,
    private fileUploadMultipleService: FileUploadMultipleService,
    private _cdr: ChangeDetectorRef,
    private changeDetectorRef: ChangeDetectorRef,
    public _QnSbnDataService: QnSbnDataServiceService,
    public _QnSbnService: QnSbnService,
    public router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {

    this.storedData = changes['data']?.currentValue[2];
    this.docsDataForDeletion = changes['data']?.currentValue[0];
    this.attachmentDataForDeletion = changes['data']?.currentValue[1];

    if (
      this.docsDataForDeletion.length > 0 &&
      this.attachmentDataForDeletion.length > 0
    ) {
      if (
        this.docsDataForDeletion?.some(obj => Object.keys(obj).length > 0) &&
        this.attachmentDataForDeletion?.some(obj => Object.keys(obj).length > 0)
      ) {
        this.allAttachments = [
          ...this.docsDataForDeletion,
          ...this.attachmentDataForDeletion,
        ];
      } else if (
        this.attachmentDataForDeletion?.some(obj => Object.keys(obj).length > 0)
      ) {
        this.allAttachments = [...this.attachmentDataForDeletion];
      } else if (
        this.docsDataForDeletion?.some(obj => Object.keys(obj).length > 0)
      ) {
        this.allAttachments = [...this.docsDataForDeletion];
      }
    } else if (
      this.docsDataForDeletion.length == 0 &&
      this.attachmentDataForDeletion.length > 0
    ) {
      if (
        this.attachmentDataForDeletion?.some(obj => Object.keys(obj).length > 0)
      ) {
        this.allAttachments = [...this.attachmentDataForDeletion];
      }
    } else if (
      this.docsDataForDeletion.length > 0 &&
      this.attachmentDataForDeletion.length == 0
    ) {
      if (this.docsDataForDeletion?.some(obj => Object.keys(obj).length > 0)) {
        this.allAttachments = [...this.docsDataForDeletion];
      }
    } else {
      this.allAttachments = [];
    }

    if (this.allAttachments?.some(item => 'Status' in item)) {
      this.allAttachments = this.allAttachments.filter(
        item => !(item?.Status === 'Removed'),
      );
    }
    this.allAttachments = this.allAttachments?.map((att, index) => ({
      ...att,
      id: index,
    }));
    this.filteredGLobalAttachments = this.allAttachments.filter(a => a?.PIMID);
    this.filteredLocalAttachments = this.allAttachments.filter(a => !a?.PIMID);


    this.fileUploadMultipleService.allAddedFiles$.subscribe(val => {
      this.uploadingFiles = val;
    });

    this.notificationDetailsService.diableFullScreen$.subscribe(val => {
      this.isAdding = val;
    });

    this.notificationDetailsService.setFilesToBeAddedLength(
      11 - this.allAttachments?.length,
    );

    // Clear stale file upload data so the upload area only shows newly added files
    this._QnSbnDataService.getMappedQnsbnData({
      fileList: [],
      totalAllFileSize: 0,
      fileSizeobject: {},
    }, 'MessageAttachmentFileList');
    this.fileUploadMultipleService.setOpenJustificationDialogToggle([]);
    this.notificationDetailsService.setSelectedFilesToAdd([]);

    this._cdr.detectChanges();
  }

  ngOnInit(): void {
  }

  

  ngAfterViewInit() {
    this.parentScroll.nativeElement.addEventListener('scroll', () => {
      const scrollTop = this.parentScroll.nativeElement.scrollTop;
      this.isScrolled = scrollTop > 0;
    });
    this.notificationDetailsService.diableFullScreen$.subscribe(val => {
      this.isAdding = val;
    });
    this._cdr.detectChanges();
  }

  toggleSelectAll(event) {
    if (event?.target?.checked) {
      this.allAttachments.forEach(att => {
        this.selectedIds.add(att.id);
      });
    } else {
      this.allAttachments.forEach(att => {
        this.selectedIds.delete(att.id);
      });
    }
  }

  checked(event) {
    if (
      this.selectedIds.size == this.allAttachments.length &&
      this.allAttachments.length != 0
    ) {
      event.target.checked = true;
    } else {
      event.target.checked = false;
    }
  }

  onSelectionChange(event, key, data) {

    if(this.notificationDetailsService.selectedDeletingItems.length!=0 && this.notificationDetailsService.selectedIds.size!=0){
      this.notificationDetailsService.selectedDeletingItems=[];
      this.notificationDetailsService.selectedIds.clear()
    }

    const isChecked = event?.target?.checked;

    if (isChecked) {
      this.selectedIds.add(data.id);
    } else {
      this.selectedIds.delete(data.id);
    }
    
  }

  deleteSelected() {
    this.notificationDetailsService.setOpenJustificationDialogToggle(true);

    if(this.selectedIds.size==0){
      this.selectedIds = this.notificationDetailsService.selectedIds;
    }
    else{
      this.notificationDetailsService.selectedIds = this.selectedIds;
    }

    if (this.notificationDetailsService.selectedDeletingItems?.length != 0) {
      this.selectedItems =
        this.notificationDetailsService.selectedDeletingItems;
    } else {
      this.selectedItems = this.allAttachments.filter(item =>
        this.selectedIds.has(item?.id),
      );
      this.notificationDetailsService.selectedDeletingItems =
        this.selectedItems;
    }

    this.attachmentDataForDeletion = this.allAttachments.filter(
      item => item?.PIMID,
    );
    this.docsDataForDeletion = this.allAttachments.filter(item => !item?.PIMID);

    this.justification.emit([
      this.attachmentDataForDeletion,
      this.docsDataForDeletion,
      this.selectedIds.size,
      this.selectedItems,
    ]);
  }

  public async btnSendNotificationClicked(): Promise<void> {
    this.newUploadedFiles = this.uploadingFiles;
    this.fileData = [
      ...this.fileUploadMultipleService.getOpenJustificationDialogToggle(),
    ];
    this.isAdding = true; // 👈 change text immediately
    this._cdr.detectChanges();
    this.notificationDetailsService.setDiableFullScreenToggle(true);
    this.fileUploadMultipleService.setOpenJustificationDialogToggle([]);

    let addData = [];
    let waitData = [];
    for (let f = 0; f <= this.fileData.length - 1; f++) {
      if (this.fileData[f].uploadFile) {
        try {
          this.output = await this._QnSbnService.dataToBeSaveOnS3Only(
            this.fileData[f],
            this.storedData['NotificationId'],
          );

          if (this.output?.statusCode == 200) {
            addData.push(this.fileData[f]);
          } else if (this.output?.statusCode == 400) {
            waitData.push(this.fileData[f]);
          } else {
            waitData.push(this.fileData[f]);
          }
        } catch (err) {
          console.error('Error for file:', this.fileData[f], err);
          this.snackBarNotification.snackBarMessage(
            'alarm',
            'File upload failed.',
          );
          this.notificationDetailsService.setDiableFullScreenToggle(false);
          this._cdr.detectChanges();
          this.router.navigate(['/notification']);
          // ❗ loop continues instead of breaking
          return null;
        }
      }
    }

    if (waitData.length > 0) {
      const fileNames = waitData.map(data => `"${data.name}"`).join(', ');
      const word = waitData.length > 1 ? 'attachments are' : 'attachment is';
      let adjective;
      if (this.fileData.length == waitData.length && waitData.length > 1) {
        adjective = 'All '+this.fileData.length;
      } else {
        adjective = fileNames;
      }
      this.snackBarNotification.snackBarMessage(
        'alarm',
        adjective + ' ' + word + ' failed while uploading.',
      );
      if (this.fileData.length == waitData.length) {
        this.allAddedFiles.emit([]);
        this.isAdding = false; // 👈 change text immediately
        this.notificationDetailsService.setDiableFullScreenToggle(false);
        this._cdr.detectChanges();
        //   sessionStorage.setItem('reloadOverview', 'true');
        this.filesData = [];
        this.notificationDetailsService.setSelectedFilesToAdd([]);
        this._cdr.detectChanges();
        this.router.navigateByUrl('/notification');
        this._cdr.detectChanges();
      }
    }

    if (addData.length > 0) {
      this.addAllAttachmentsApiCall(addData);
    }
  }

  public addAllAttachmentsApiCall(dataToBeAdd): void {
    let sendUploadedDataToAdd;
    if (this.fileData.length > 1) {
      const attachments = [];
      dataToBeAdd.map(data => {
        attachments.push({
          attachmentFilename: data.name,
          fileSize: data.size,
          fileType: data.type,
        });
      });
      sendUploadedDataToAdd = {
        action: 'ADD_ATTACHMENT',
        notificationId: this.storedData.NotificationId,
        userId: this.storedData.UserId,
        userRole: this.storedData.UserRole,
        attachments: attachments,
      };
    } else {
      sendUploadedDataToAdd = {
        action: 'ADD_ATTACHMENT',
        notificationId: this.storedData.NotificationId,
        userId: this.storedData.UserId,
        userRole: this.storedData.UserRole,
        attachmentFilename: dataToBeAdd[0].name,
        fileSize: dataToBeAdd[0].size,
        fileType: dataToBeAdd[0].type,
      };
    }
    this._QnSbnService
      .addNewAttachmentsInNotification(sendUploadedDataToAdd)
      .subscribe(
        res => {
          if (dataToBeAdd.length > 1) {
            const skippedAttachments =
              res?.body?.results?.skipped ?? res?.body?.details?.skipped;
            const successedAttachments =
              res?.body?.results?.successful ?? res?.body?.details?.successful;
            const failedAttachments =
              res?.body?.results?.failed ?? res?.body?.details?.failed;

            if (skippedAttachments?.length > 0) {
              const fileNames = skippedAttachments
                .map(data => `"${data.filename}"`)
                .join(', ');
              const word =
                skippedAttachments.length > 1
                  ? 'attachments are'
                  : 'attachment is';
              let adjective;
              if (
                this.fileData.length == skippedAttachments.length &&
                skippedAttachments.length > 1
              ) {
                adjective = 'All '+ this.fileData.length;
              } else {
                adjective = fileNames;
              }
              this.snackBarNotification.snackBarMessage(
                'alarm',
                adjective +
                  ' ' +
                  word +
                  ` skipped. Already exists in the notification either in active state or removed state.`,
              );
            }
            if (successedAttachments?.length > 0) {
              const fileNames = successedAttachments
                .map(item =>
                  typeof item === 'string'
                    ? `"${item}"`
                    : `"${item?.filename}"`,
                )
                .join(', ');
              const word =
                successedAttachments.length > 1
                  ? 'attachments are'
                  : 'attachment is';
              let adjective;
              if (
                this.fileData.length == successedAttachments.length &&
                successedAttachments.length > 1
              ) {
                adjective = 'All '+this.fileData.length;
              } else {
                adjective = fileNames;
              }
              this.snackBarNotification.snackBarMessage(
                'positive',
                adjective +
                  ' ' +
                  word +
                  ` added successfully in the notification`,
              );
              const updatedDataToBeSend = [];
              dataToBeAdd.map(data => {
                successedAttachments.map(resData => {
                  if (data.name === resData) {
                    updatedDataToBeSend.push(data);
                  }
                });
              });
              this.allAddedFiles.emit({
                response: res,
                addedFiles: updatedDataToBeSend,
              });
            }
            if (failedAttachments?.length > 0) {
              const fileNames = failedAttachments
                .map(item =>
                  typeof item === 'string'
                    ? `"${item}"`
                    : `"${item?.filename}"`,
                )
                .join(', ');
              const word =
                failedAttachments.length > 1
                  ? 'attachments are'
                  : 'attachment is';
              let adjective;
              if (
                this.fileData.length == failedAttachments.length &&
                failedAttachments.length > 1
              ) {
                adjective = 'All '+this.fileData.length;
              } else {
                adjective = fileNames;
              }
              this.snackBarNotification.snackBarMessage(
                'alarm',
                adjective +
                  ' ' +
                  word +
                  ` failed while adding in the notification`,
              );
            }
          } else {
            const singleAttachmentAddition = res?.body?.attachment?.Status;
            const skippedAttachments =
              res?.body?.results?.skipped ?? res?.body?.details?.skipped;
            if (singleAttachmentAddition === 'Active') {
              this.snackBarNotification.snackBarMessage(
                'positive',
                res?.body?.attachment?.FileName +
                  ' attachment is added successfully in the notification',
              );
              this.allAddedFiles.emit({
                response: res,
                addedFiles: dataToBeAdd,
              });
            } else if (skippedAttachments?.length > 0) {
              this.snackBarNotification.snackBarMessage(
                'alarm',
                `"${skippedAttachments[0].filename}" attachment is skipped. Already exists in the notification either in active state or removed state.`,
              );
            } else {
              this.snackBarNotification.snackBarMessage(
                'alarm',
                dataToBeAdd[0]?.name +
                  ' attachment is failed while adding in the notification',
              );
            }
          }
          if (res.statusCode == 200) {
            this.isAdding = false; // 👈 change text immediately
            this.notificationDetailsService.setDiableFullScreenToggle(false);
            this._cdr.detectChanges();
            this.filesData = [];
            this.notificationDetailsService.setSelectedFilesToAdd([]);
            this._cdr.detectChanges();
          } else {
            this.allAddedFiles.emit([]);
            this.isAdding = false; // 👈 change text immediately
            this.notificationDetailsService.setDiableFullScreenToggle(false);
            this._cdr.detectChanges();
            this.filesData = [];
            this.notificationDetailsService.setSelectedFilesToAdd([]);
            this.router.navigateByUrl('/notification');
            this._cdr.detectChanges();
          }
        },
        (error: HttpErrorResponse) => {
          const fileNames = dataToBeAdd
            .map(data => `"${data.name}"`)
            .join(', ');
          const word =
            dataToBeAdd.length > 1 ? 'attachments are' : 'attachment is';
          let adjective;
          if (
            this.fileData.length == dataToBeAdd.length &&
            dataToBeAdd.length > 1
          ) {
            adjective = 'All '+this.fileData.length;
          } else {
            adjective = fileNames;
          }
          this._QnSbnService.httpErrorHandler(
            error,
            adjective + ' ' + word + ' adding in the notification failed.',
          );
          this.allAddedFiles.emit([]);
          this.isAdding = false; // 👈 change text immediately
          this.notificationDetailsService.setDiableFullScreenToggle(false);
          this._cdr.detectChanges();
          this.filesData = [];
          this.router.navigateByUrl('/notification');
          this.notificationDetailsService.setSelectedFilesToAdd([]);
          this._cdr.detectChanges();
        },
      );
  }

  cancelClicked() {
    this.justification.emit([]);
    this.notificationDetailsService.setSelectedFilesToAdd([]);
    this.selectedIds.clear();
    this.selectedItems = [];
    this.notificationDetailsService.selectedDeletingItems = [];
    this._cdr.detectChanges();
  }
}
